import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm, UseFormSetError } from "react-hook-form";
import { useParams } from "react-router-dom";
import { IComponent } from "../../types/interface";
import { componentValidation } from "../../utils/validationSchema";
import ComponentForm from "./Form";

interface Props {
  handleUpdate: (
    data: IComponent,
    setError: UseFormSetError<IComponent>
  ) => Promise<void>;
  isUpdatingComponent: boolean;
  componentInfo: IComponent;
}

export default function CreateComponent({
  handleUpdate,
  isUpdatingComponent,
  componentInfo,
}: Props) {
  const updateComponentMethods = useForm<IComponent>({
    defaultValues: { ...componentInfo },
    resolver: yupResolver(componentValidation),
  });

  return (
    <FormLayout
      isLoading={isUpdatingComponent}
      handleSubmit={updateComponentMethods.handleSubmit}
      handleFormSubmit={handleUpdate}
      buttonLabel="Update"
      disabled={isUpdatingComponent}
      setError={updateComponentMethods.setError}
    >
      <FormProvider {...updateComponentMethods}>
        <ComponentForm />
      </FormProvider>
    </FormLayout>
  );
}
